export default __webpack_public_path__ + "static/media/about.fffeb072.png";